import { render, staticRenderFns } from "./ErpPixBank.vue?vue&type=template&id=26fee3d4&"
import script from "./ErpPixBank.vue?vue&type=script&lang=js&"
export * from "./ErpPixBank.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports